/* One line: the reason, then the way out. The cell cuts it with an ellipsis and its title holds the whole
   text (`noteText`), so a refused document does not make its row three lines tall. */
.note {
  display: flex;
  min-width: 0;
  gap: 6px;
  white-space: nowrap;
}

.reason {
  color: var(--crit);
  font-weight: 600;
}

.remedy {
  color: var(--ink-2);
}
